import { render, staticRenderFns } from "./ComOdoToTreatment.vue?vue&type=template&id=406233c3&"
import script from "./ComOdoToTreatment.vue?vue&type=script&lang=js&"
export * from "./ComOdoToTreatment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports